import React from "react";
import { CheckboxFormField } from "@components/FormField/HookFormFields";
import { i18, trb } from "@utilities";

export const Confirmation = React.memo(({ control }) => {
  return (
    <div className="row my-4">
      <div className="col-12 ant-alert ant-alert-warning ant-alert-with-description">
        <CheckboxFormField
          name="Approve"
          control={control}
          label={trb(i18.NotificationMessages.KYCApproveSubmit)}
          inline={true}
        />
      </div>
    </div>
  );
});
